import { fetcher } from "helpers/fetcher";

import { TGetStaffRetirementPaymentRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getStaffRetirementPayment = async (userId: string) => {
  return await fetcher<TGetStaffRetirementPaymentRes, any>(
    ENDPOINT.USER.GET_STAFF_RETIREMENT_PAYMENT,
    {
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.USER.GET_STAFF_RETIREMENT_PAYMENT.version,
        [API_HEADER.USER_ID]: userId,
      },
    }
  );
};

export const queryGetStaffRetirementPayment = async (userId: string) => {
  return (await getStaffRetirementPayment(userId)).data;
};

queryGetStaffRetirementPayment._key = (userId: string) => [
  ENDPOINT.USER.GET_STAFF_RETIREMENT_PAYMENT.url,
  userId,
];
